import React, { useState } from 'react';
import styled from 'styled-components';
import { postProfileImage } from '../../api/login';
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation';

type ProfileImageType = {
  default: boolean;
  name: string;
  png: string;
  svg: string;
};

export function PictureModal({
  setPictureModal,
  profileImages,
  setSelectImage,
  profileImage,
  pictureModal,
}: {
  setPictureModal: React.Dispatch<React.SetStateAction<boolean>>;
  profileImages: ProfileImageType[];
  setSelectImage: React.Dispatch<React.SetStateAction<string>>;
  profileImage: string;
  pictureModal: boolean;
}) {
  const [closing, setClosing] = useState<boolean>(false);
  const [upload, setUpload] = useState<string>();

  const closeModal = () => {
    setClosing(true);

    setTimeout(() => {
      setPictureModal(false);
      setClosing(false);
    }, 280);
  };

  if (!pictureModal) return null;

  function uploadFile(e: any) {
    if (!e.target.files) {
      return;
    }
    const pictureSize = e.target.files[0].size;
    const maxSize = 5 * 1024 * 1024;

    if (pictureSize > maxSize) {
      alert('첨부할 수 있는 이미지 파일은 5MB이하입니다.');
      return;
    }
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    postProfileImage(formData)
      .then((res) => {
        setUpload(res.data.url);
      })
      .catch((err) => console.log(err));
  }

  //브라우저상에 보여질 첨부파일

  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <p>프로필 사진 선택</p>
          <button type="button" onClick={closeModal}>
            <img src="../../images/icon_close.png" alt="" />
          </button>
        </ModalHeader>
        <ModalBody>
          <div className="profile_cont">
            <div
              className="img_fix"
              style={{
                backgroundImage: upload
                  ? `url(${upload})`
                  : profileImage
                  ? `url(${profileImage})`
                  : 'url(../../images/profile_img.png)',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px inset',
              }}
            ></div>
            <div className="img_list">
              <div className="select_img">
                <input
                  type="file"
                  id="profile_img"
                  name=""
                  onChange={(e) => {
                    uploadFile(e);
                  }}
                />
                <label
                  htmlFor="profile_img"
                  style={{
                    backgroundImage: 'url(../../images/icon_no_picture.png)',
                    boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px inset',
                  }}
                ></label>
              </div>
              {profileImages?.map((el: any) => {
                return (
                  <img
                    src={el.png}
                    alt=""
                    style={{
                      borderRadius: '50%',
                      boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px inset',
                    }}
                    key={el.png}
                    onClick={() => {
                      setUpload(el.png);
                    }}
                  />
                );
              })}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn_black"
            onClick={() => {
              setSelectImage(upload || '');
              closeModal();
            }}
          >
            저장
          </button>
        </ModalFooter>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  );
}
interface typeProps {
  closing?: boolean;
}

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  overflow: hidden;
`;

export const ModalBox = styled.div<typeProps>`
  width: 100%;
  background-color: var(--colWhite);
  border-radius: 18px 18px 0 0;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
  bottom: 0;
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 18.5px 22px 0 33px;
  align-items: center;
  & p {
    flex: 1;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
  }
  & button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 41px;
    height: 48px;
    padding: 12px 8px 12px 9px;
    border: none;
    background: transparent;
    & img {
      width: 100%;
      height: 100%;
    }
  }
`;
export const ModalBody = styled.div`
  & .profile_cont {
    padding: 8px 0;
    & .img_fix {
      margin: 0 auto 24px;
      width: 128px;
      height: 128px;
      border-radius: 50%;
      overflow: hidden;
      & img {
        width: 100%;
      }
    }
    & .img_list {
      display: flex;
      gap: 12px;
      overflow-x: scroll;
      overflow-y: hidden;
      padding: 0 33px;
      & .select_img {
        & input {
          padding: 0;
          font-size: 0;
          line-height: inherit;
          color: transparent;
          letter-spacing: 0;
          width: 0 !important;
          display: none;
        }
        & label {
          display: block;
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
      & img {
        width: 56px;
        height: 56px;
      }
    }
  }
`;
export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 33px;
  & button.btn_black {
    width: 100%;
    height: 48px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    background: var(--colBlack);
    color: var(--colWhite);
    border-radius: 5px;
    border: none;
  }
`;
export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`;
